import { render, staticRenderFns } from "./related-sp.vue?vue&type=template&id=0ba25be0&"
import script from "./related-sp.vue?vue&type=script&lang=js&"
export * from "./related-sp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports